<template>
  <div class="autumn-course-member-review-video">
    <img class="header-img"
         :src="require('@/pages/2020/SpringCourse/assets/img/students-comment.png')"
         alt="学员评价视频"
    />
    <ym-video class="ym-video-component"
              :src="src"
              :poster="poster"
    />
    <div class="benefit-info-block">
      <div class="title">2020春季学期5月视频直播课(八大主题)</div>
      <div class="action-status">
        <span>限时报名中</span>
      </div>
      <div class="benefit-save">
        <span>
          老学员报名
          <span class="red">立减50元</span>
        </span>
      </div>
      <div class="benefit-price">
        <span>会员专享9折<span class="del-text">（原价980元）</span></span>
      </div>
      <div class="hint">*费用包括：课程费、精美主题工具包及学习证书等</div>
    </div>
    <div class="promise-info">
      <div class="title">温馨提示：</div>
      <div class="change-info">从报课成功到首次课程结束，您将有一次无条件退换课机会；</div>
      <div class="interest">购买课程后，您还将额外获得相应积分奖励（实付1元=10积分），积分可抵现。</div>
    </div>
  </div>
</template>

<script>
  import YmVideo from '@/components/YmVideo';

  export default {
    name: 'AutumnCourseMemberReviewVideo2019',
    components: {
      YmVideo,
    },
    props: {
      poster: {
        type: String,
        required: true,
      },
      src: {
        type: String,
        required: true,
      },
      status: {
        type: String,
        required: true,
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @color-high-light: #ff7508;

  .autumn-course-member-review-video {
    padding: 58px 60px 38px 60px;
    background: @color-white;
  }

  .header-img {
    margin:0 0 24px 16px;
    display: block;
    width: 312px;
    height: 66px;
  }

  /deep/ .ym-video-component {
    margin: 0 auto 102px;
    height: 326px;
  }

  .benefit-info-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      margin-bottom: 24px;
      color: #1777C0;
      font-size: 36px;
      font-weight: @font-weight-bold;
      text-align: center;
      line-height: 1;
    }
    .action-status {
      margin-bottom: 24px;
      width: 238px;
      height: 50px;
      background: #FFD427;
      border-radius: 25px;
      text-align: center;
      line-height: 50px;
      color: #333;
      font-weight: @font-weight-bold;
    }

    .benefit-save {
      font-size: @font-size-base;
      font-weight: @font-weight-bold;
      color: #1777C0;
      line-height: 1;
      &:not(:last-child) {
        margin-bottom: @size-small;
      }
      .red {
        color: #F51127;
        font-size: 42px;
      }
    }

    .benefit-price {
      margin-bottom: 16px;
      font-size: 26px;
      color: @color-text-base;
      .del-text {
        position: relative;
        &:after {
          width: calc(100% - 20px);
          height: 1px;
          background: @color-black-dark;
          content: '';
          position: absolute;
          left: @size-extra-small;
          bottom: @size-extra-small;
        }
      }
    }
    .hint {
      margin-bottom: 52px;
      font-size: @font-size-extra-small;
      color: @color-text-light;
    }
  }
  .promise-info {
    width: 630px;
    margin-bottom: @size-extra-medium;
    padding: @size-base @size-medium;
    box-sizing: border-box;
    background: fade(#C3E8E7, 34%);
    border-radius: 10px;
    font-weight: @font-weight-bold;
    font-size: @font-size-small;
    line-height: 1.6;
    .title {
      margin-bottom: 16px;
      font-size: 26px;
      color: #2284B2;
      line-height: 1;
    }
    .change-info {
      margin-bottom: 16px;
      color: @color-text-base;
    }
    .interest {
      color: #666666;
      font-size: 18px;
    }
  }
  .join-info-block {
    padding-bottom: 55px;
    font-size: 26px;
    font-weight: @font-weight-bold;
    text-align: center;
    line-height: 1;
    color: @color-high-light;
    .text {
      position: relative;
      &:after {
        margin: 0 auto;
        position: absolute;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: @size-base solid @color-high-light;
        content: '';
        bottom: -55px;
        left: 0;
        right: 0;
      }
    }
  }

</style>
